module.exports = __webpack_public_path__ + "img/Transitry_cx.77dcb120.png";